import { cloneDeep, isEqual } from 'lodash'
import { axiosRequest } from '@/plugins/axios-common'
import { filterValidParties } from '@/utilities/party'
import { handleError } from '@/store/handle-error'

import { virginLegalCase } from '@/store/legal-case/state'

export const REQUIRED_PROPERTIES = [
  'first_name',
  'gender_id',
  'last_name',
]

export const LegalCaseEditState = {
  legalCaseEdit: {
    edited: null,
    original: null,
  },
}

export const LegalCaseEditGetters = {
  edited: state => state.legalCaseEdit.edited,
  original: state => state.legalCaseEdit.original,
  wasChanged: state => !isEqual(
    state.legalCaseEdit.edited,
    state.legalCaseEdit.original
  ),
}

export const LegalCaseEditMutations = {
  setEdited: (state, value) => {
    state.legalCaseEdit.edited = {
      ...virginLegalCase,
      ...value,
    }
  },

  setOriginal: (state, value) => { state.legalCaseEdit.original = { ...value } },
}

export const LegalCaseEditActions = {
  getEngagementLetterContent: async ({ commit, state }, languageId) => {
    axiosRequest.get(`/legal_cases/engagement_letters/by_language/${languageId}`).
      then(({ data }) => {
        commit('setEdited', {
          ...state.legalCaseEdit.edited,
          engagement_letter: { ...state.legalCaseEdit.edited.engagement_letter, content: data.content },
        })
      })
  },

  resetEdited: ({ commit, state }) => commit('setEdited', state.legalCaseEdit.original),

  saveEdited: async ({ commit, state }) => {
    const data = cloneDeep(state.legalCaseEdit.edited)
    data.parties = filterValidParties(data.parties)
    if ([null, undefined].includes(data.engagement_letter.language_id)) data.engagement_letter = {}
    let request = null

    // Editing a case?
    if (state.legalCaseEdit.edited.id) {
      request = axiosRequest.patch(
        `/legal_cases/${state.legalCaseEdit.edited.id}`,
        { legal_case: data }
      )

    // Or creating a case?
    } else {
      request = axiosRequest.post(
        '/legal_cases',
        { legal_case: data }
      )
    }

    return request.
      then(({ data }) => data).
      catch(handleError)
  },

  setEdited: ({ commit }, value) => commit('setEdited', cloneDeep(value)),
  setOriginal: ({ commit }, value) => commit('setOriginal', cloneDeep(value)),
}
